"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainMenuCharacter = void 0;
const Class_1 = require("./Class");
const definables_1 = require("definables");
const Figure_1 = require("./Figure");
const Item_1 = require("./Item");
const SkinColor_1 = require("./SkinColor");
class MainMenuCharacter extends definables_1.Definable {
    constructor(options) {
        var _a, _b, _c, _d;
        super(options.id);
        this._classID = options.classID;
        this._clothesDyeItemID = (_a = options.clothesDyeItemID) !== null && _a !== void 0 ? _a : null;
        this._figureID = options.figureID;
        this._hairDyeItemID = (_b = options.hairDyeItemID) !== null && _b !== void 0 ? _b : null;
        this._level = options.level;
        this._maskItemID = (_c = options.maskItemID) !== null && _c !== void 0 ? _c : null;
        this._outfitItemID = (_d = options.outfitItemID) !== null && _d !== void 0 ? _d : null;
        this._skinColorID = options.skinColorID;
    }
    get class() {
        return (0, definables_1.getDefinable)(Class_1.Class, this._classID);
    }
    get clothesDyeItem() {
        if (this._clothesDyeItemID !== null) {
            return (0, definables_1.getDefinable)(Item_1.Item, this._clothesDyeItemID);
        }
        throw new Error(this.getAccessorErrorMessage("clothesDyeItem"));
    }
    get figure() {
        return (0, definables_1.getDefinable)(Figure_1.Figure, this._figureID);
    }
    get hairDyeItem() {
        if (this._hairDyeItemID !== null) {
            return (0, definables_1.getDefinable)(Item_1.Item, this._hairDyeItemID);
        }
        throw new Error(this.getAccessorErrorMessage("hairDyeItem"));
    }
    get level() {
        return this._level;
    }
    get maskItem() {
        if (this._maskItemID !== null) {
            return (0, definables_1.getDefinable)(Item_1.Item, this._maskItemID);
        }
        throw new Error(this.getAccessorErrorMessage("maskItem"));
    }
    get outfitItem() {
        if (this._outfitItemID !== null) {
            return (0, definables_1.getDefinable)(Item_1.Item, this._outfitItemID);
        }
        throw new Error(this.getAccessorErrorMessage("outfitItem"));
    }
    get skinColor() {
        return (0, definables_1.getDefinable)(SkinColor_1.SkinColor, this._skinColorID);
    }
    hasClothesDyeItem() {
        return this._clothesDyeItemID !== null;
    }
    hasHairDyeItem() {
        return this._hairDyeItemID !== null;
    }
    hasMaskItem() {
        return this._maskItemID !== null;
    }
    hasOutfitItem() {
        return this._outfitItemID !== null;
    }
}
exports.MainMenuCharacter = MainMenuCharacter;
